<template>
  <data-chip
    :text="statusText(status)"
    :color="statusColor(status)"
    :iconLeft="statusIcon(status)"
    :small="small"
  >
  </data-chip>
</template>

<script>
import DataChip from "@/components/_systemwide/DataChip.vue";
export default {
  name: "time-sheet-status-chip",
  components: {
    DataChip,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    statusText(statusId) {
      switch (statusId) {
        case "toBeProcessed":
          return "In Verarbeitung";
        case "missingPayrollType":
          return "Fehlende Abrechungsart";
        case "inProgress":
          return "In Bearbeitung";
        case "toBeReviewed":
          return "Zu prüfen";
        case "rejected":
          return "Abgelehnt";
        case "approved":
          return "Genehmigt";
        case "completed":
          return "Festgeschrieben";
        case "archived":
          return "Archiviert";
        default:
          return "Fehler";
      }
    },
    statusIcon(statusId) {
      switch (statusId) {
        case "toBeProcessed":
          return "progress-clock";
        case "missingPayrollType":
          return "help-circle";
        case "inProgress":
          return "pencil-box-multiple";
        case "toBeReviewed":
          return "check-all";
        case "rejected":
          return "close-circle";
        case "approved":
          return "check-circle";
        case "completed":
          return "archive-check";
        case "archived":
          return "archive-cancel";
        default:
          return "alert";
      }
    },
    statusColor(statusId) {
      switch (statusId) {
        case "toBeProcessed":
          return "blue";
        case "missingPayrollType":
        case "inProgress":
          return "orange";
        case "toBeReviewed":
          return "purple";
        case "rejected":
          return "red";
        case "approved":
        case "completed":
          return "green";
        case "archived":
          return "blue-grey";
        default:
          return "grey";
      }
    },
  },
};
</script>
